import { getSprayConditionsTitleAndColor } from 'App/Map/_utils/getSprayConditionsTitleAndColor'
import type { TValueGroupColumns } from 'App/Map/PanelDetails/OverviewCharts/_utils/types'
import { EllipsisTooltip } from 'App/Map/PanelDetails/OverviewCharts/EllipsisTooltip'
import { BadgeCell } from 'App/Map/PanelDetails/SummaryGridTable/BadgeCell/BadgeCell'
import type { ESprayRecommendation } from 'App/Map/types'
import { translate } from 'i18n/i18n'

export const spraysColumns: Record<string, TValueGroupColumns> = {
  spray_conditions: {
    leadingColumn: 'blockName',
    getColumns: () => [
      {
        title: <EllipsisTooltip fullText={translate.phrases.banyanApp('Conditions')} />,
        dataIndex: 'sprayConditions_currentHour',
        key: 'sprayConditions_currentHour',
        width: 150,
        render: (value: ESprayRecommendation | null) => {
          const { color, name } = getSprayConditionsTitleAndColor(value)

          return <BadgeCell backgroundColor={color}>{name}</BadgeCell>
        },
      },
    ],
  },
}
